/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const incidentsStrings = {
  messagePreview: 'Message preview',
  previewSafety: 'Safe preview. Images, links and interactive content are disabled for your protection.',
  technicalDetails: 'Technical report details',
  sections: { reports: 'Reports', settings: 'Settings' },
  categoryForm: 'Add a category',
  categoryEdit: 'Edit the category',
  title: 'Manage Security Reports',
  subtitle: 'Review security reports from users',
  manageCategories: 'Security Report Settings',
  featureSwitch: 'Activate Security Reports Feature',
  displayOptions: 'Security Reports Display Options',

  columns: {
    index: 'ID',
    id: 'Report Number',
    title: 'Report Title',
    category: 'Category',
    createdOn: 'Creation Date',
    lastUpdate: 'Last Updated',
    reporter: 'Reporter Name',
    state: 'Report State',
  },

  row: {
    view: 'View Details',
  },

  changeState: 'Report State',
  subCategory: 'Subcategory',
  noSubCategory: 'No subcategory',
  changeStateHint: 'Changing the state emails the reporter',
  stateSaved: 'The state was updated',
  details: 'Report details',
  reportContent: 'Report content',
  download: 'Download',
  attachments: 'Attachments',
  comments: 'Comments',
  noComments: 'No comments on this report',
  addComment: 'Add a comment',
  commentAdded: 'The comment was added',
  commentPlaceholder: 'Write a comment the reporter will see',
  notFound: 'Report not found',
  notFoundHint: 'It may have been deleted, or the number is wrong',

  categoriesHint: 'The categories a user picks from when filing a report',
  category: {
    nameAr: 'Arabic Name',
    nameEn: 'English Name',
    parent: 'Parent category',
    parentHint: 'Leave empty to make it a top-level category',
    noParent: 'No parent category',
    existing: 'Existing categories',
    empty: 'No categories yet — the feature cannot be switched on until at least one exists',
    deleteConfirm: 'This category and every sub-category under it will be deleted permanently. It cannot be deleted if any of them is used by a report.',
  },

  addNew: 'Add',
  edit: 'Update',
  delete: 'Delete',
  saved: 'Saved successfully',
  deleted: 'Deleted successfully',
  namesRequired: 'Both the Arabic and English names are required',
  empty: 'No reports',
  actionFailed: 'The operation could not be completed',
  fail: {
    list: 'Could not load the reports',
    settings: 'Could not load the report settings',
    saveCategory: 'Could not save the report category',
    deleteCategory: 'Could not delete the report category',
    state: 'Could not change the report state',
    comment: 'Could not add the comment',
  },

  states: {
    New: 'New',
    InProgress: 'In Progress',
    Completed: 'Closed (valid report)',
    Closed: 'Cancelled (false report)',
  },

  /* EMPTY, which the page reads as `no state filter` — every report, whatever
     its state. It opened on New + InProgress, so two of the four cards were
     already narrowing the list before anyone chose anything, and the totals
     above disagreed with the rows below. */
  defaultStates: [],

  stats: {
    caption: 'Reports at a glance',
    total: 'Total reports',
  },

  apply: 'Update',
  cancel: 'Cancel',
  close: 'Close',
}

export const validationStrings = {
  title: 'Certificate Validation',
  panelTitle: 'Certificate Validation',
  heading:
    'Enter the 6- or 12-character code printed on the certificate, without its prefix, to validate it.',
  placeholder: 'Validation Code',
  validate: 'Validate',
  invalidCode: 'Please enter a valid 6- or 12-character code',
  checkFailed: 'The code could not be checked right now. Try again.',

  validHead: 'Valid Certificate',
  validSubHead: 'The certificate code is valid and the Certificate has been issued from the system',
  invalidHead: 'Invalid Certificate',
  invalidSubHead: 'The certificate code was not found.',

  fields: {
    identifier: 'Validation Code',
    printedBy: 'Printed By Username',
    printedFor: 'Print For Username',
    issueDate: 'Issue Date',
    printedName: 'Printed Name',
    printedProgram: 'Printed Program Name',
    printedCertDate: 'Printed Certificate Date',
    language: 'Printing Language',
  },
}
